module.exports = __webpack_public_path__ + "static/media/AvenirLTStd-Medium.fa6b0067.ttf";